<script setup>
import { computed } from 'vue';
import { emitter } from 'shared/helpers/mitt';
import { BUS_EVENTS } from 'shared/constants/busEvents';
import { useReminder } from 'dashboard/composables/useReminder';
import { formatReminderDueTime } from 'dashboard/helper/reminderHelper';
import NextButton from 'dashboard/components-next/button/Button.vue';

const { reminder, isSaving, clearReminder } = useReminder();

const dueTime = computed(() => formatReminderDueTime(reminder.value?.due_at));

// Editing reuses the composer panel rather than opening a second surface.
const onEdit = () => emitter.emit(BUS_EVENTS.EDIT_REMINDER);
</script>

<template>
  <div
    class="flex items-start gap-2 px-4 py-2 border-b bg-n-amber-2 dark:bg-n-amber-3 border-n-weak"
  >
    <span
      class="i-lucide-alarm-clock size-4 shrink-0 mt-0.5 text-n-amber-11"
      aria-hidden="true"
    />
    <div class="flex flex-col min-w-0 gap-0.5 flex-1">
      <span class="text-xs font-medium text-n-amber-11">
        {{ $t('CONVERSATION.REMINDER.BANNER.DUE', { time: dueTime }) }}
      </span>
      <!-- The note is written by an agent for other agents. Customers never
      see this strip; it lives in the dashboard only. -->
      <span class="text-sm break-words text-n-slate-12">
        {{ reminder.note }}
      </span>
      <span v-if="reminder.set_by_name" class="text-xs text-n-slate-11">
        {{
          $t('CONVERSATION.REMINDER.BANNER.SET_BY', {
            name: reminder.set_by_name,
          })
        }}
      </span>
    </div>
    <div class="flex items-center gap-1 shrink-0">
      <NextButton
        ghost
        slate
        xs
        icon="i-lucide-pencil"
        :title="$t('CONVERSATION.REMINDER.BANNER.EDIT')"
        @click="onEdit"
      />
      <NextButton
        ghost
        slate
        xs
        icon="i-lucide-trash-2"
        :title="$t('CONVERSATION.REMINDER.BANNER.DELETE')"
        :is-loading="isSaving"
        @click="clearReminder"
      />
    </div>
  </div>
</template>
